// differs from the Utility in Models.CostCalculation because the RegionPricing
// data model on Region contains different properties
import * as Models from "../.";

export interface IUtility {
  utilityId: number;
  name: string;
  active: boolean;

  regions: Models.CostCalculation.Region.Region[];
}

export class Utility implements IUtility {
  utilityId: number;
  name: string;
  active: boolean;

  regions: Models.CostCalculation.Region.Region[];

  constructor() {
    this.name = "New Utility";
    this.active = true;
    this.regions = [];
  }
}
